import PageBoilerplate from '../templates/PageBoilerplate';
import UnfilteredDashboard from '../parts/Dashboards/UnfilteredDashboard';
import FilteredDashboard from '../parts/Dashboards/FilteredDashboard';
import RequestNewCompanyCTA from '../parts/Dashboards/RequestNewCompanyCTA';

export default function Dashboards({ slug, isFiltered, name, text }) {
  return <PageBoilerplate name='Dashboards' left element={<RequestNewCompanyCTA/>}>
    {isFiltered ? <FilteredDashboard key={slug} slug={slug} name={name} text={text}/> : <UnfilteredDashboard key={slug} slug={slug}  />}
  </PageBoilerplate>;
}